import { Alert, Button } from '@platform/ui';

import { useMessages } from '../i18n';
import { ApiError } from '../lib/api';
import { problemText } from '../lib/problems';

/**
 * What a list says when its rows could not be read: the failure in the
 * platform panel's words and, where asking again can help, Tekrar Dene, which
 * shows that it is waiting (docs/11 §4). A list hands it to its DataTable as
 * `error`, so a read that failed never stands beside the list's empty state.
 */
export function ListError({ query }: { query: { error: unknown; isFetching: boolean; refetch: () => Promise<unknown> } }) {
    const t = useMessages();
    // A refusal is an answer, and asking again gets the same one. No answer at
    // all, the server's own trouble or too many requests at once can pass, so
    // those are asked again.
    const refused = query.error instanceof ApiError && query.error.status < 500 && query.error.status !== 429;
    return (
        <Alert tone="danger">
            <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
                <span>{problemText(t, query.error)}</span>
                {!refused && (
                    <Button size="sm" variant="secondary" loading={query.isFetching} onClick={() => void query.refetch()}>
                        {t.common.error.retry}
                    </Button>
                )}
            </div>
        </Alert>
    );
}
